export enum SeasonOfficialsTableFilters {
  Role = "role",
  Status = "status",
  Gender = "gender",
}
